<template>
    <button :class="classes" @click="onClick">{{text}}</button>
</template>

<script>
    export default {
        props: {
            text: {
                type: String,
                required: false
            },

            next: {
                type: Boolean,
                required: false,
                default: false
            },

            prev: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        computed: {
            classes() {
                return {
                    "c-button": true,
                    "c-button--next": this.next,
                    "c-button--prev": this.prev
                };
            }
        },

        methods: {
            onClick(value) {
                this.$emit("clicked", value);
            }
        }
    };
</script>

<style lang="scss">
    .c-button {
        padding: 0.9375rem 1.5625rem;
        background-color: #f98155;
        color: #ffffff;
        font-size: 1.125rem;
        border-radius: 0.3125rem;
        border: 0.125rem solid transparent;
        font-family: "Montserrat", sans-serif;
        text-transform: none;
        letter-spacing: 0;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
        transition: background-color 0.4s ease;

        &--next {
            padding: 0.625rem 1.875rem 0.625rem 1.25rem;
        }

        &--prev {
            padding: 0.625rem 1.375rem 0.625rem 1.5625rem;
        }

        &--download {
            padding: 1.1rem 1.5625rem;
        }

        &:hover {
            background-color: transparent;
            color: #f98155;
            border: 0.125rem solid #f98155;
        }

        &:disabled,
        &:disabled:hover {
            background-color: grey;
            border: transparent;
            color: white;
            cursor: default;
        }
    }
</style>
